import PropTypes from 'prop-types';

const BreadcrumbRoot = ({ children }) => (
  <nav aria-label="breadcrumb" className="w-full">
    <ol className="flex w-full max-w-[100vw] flex-row flex-nowrap items-center overflow-x-auto whitespace-nowrap py-4 pr-8 scrollbar-none md:overflow-x-auto lg:py-6 lg:pr-0">
      {children}
    </ol>
  </nav>
);

BreadcrumbRoot.propTypes = {
  /**
   * Components to be rendered inside component
   */
  children: PropTypes.node.isRequired,
};

export default BreadcrumbRoot;
